import BasicComprehensionClient from '../shared/BasicComprehensionClient';
import { URL } from '../../../constants/reading/ApiConstants';
import { ALL_MEASURES, MEASURE } from '../../../constants/reading/MeasuresConstants';
import { getMeasureDisplayNameByKey } from '../../../utils/shared/measureUtils';
import request from '../../request';
import { PARAM } from '../../../constants/shared/ApiConstants';

const { SKILL_NAME } = PARAM;
const { MAZE_FORMS, MAZE_INTERPS, MAZE_DELETE_RESULT, MAZE_CREATE_RESULT } = URL.MAZE;
const { MAZE } = MEASURE;
const STRING_ZERO = '0';

/**
 * Class representing a Reading MAZE client.
 * @extends BasicComprehensionClient
 */
class MAZEClient extends BasicComprehensionClient {
    constructor() {
        super(MAZE, MAZE, STRING_ZERO, {
            forms: MAZE_FORMS,
            interps: MAZE_INTERPS,
            createResult: MAZE_CREATE_RESULT,
            deleteResult: MAZE_DELETE_RESULT,
        });
    }

    createResult = mazeData => {
        const mazeResult = {
            ...this.getBasicComprehensionResult(mazeData),
            [SKILL_NAME]: getMeasureDisplayNameByKey(ALL_MEASURES, this.measure),
        };
        return request.post(this.urls.createResult, mazeResult);
    };
}

export default new MAZEClient();
